import { Card, Grid } from '@mui/material'
import React from 'react'
import Image from 'next/image';
import styles from '../../styles/pages/careers.module.scss';
import { TFunction } from 'next-i18next';

const ReasonCards = (props: Props) => {
  const { t } = props;

  const reason_cards = [
  { reasonHeading: t('reason1-h3'), reasonDescription: t('reason1-p'), reasonIcon: 'https://cdn.solssmart.org/static/careers/reasons/international-team.png'}, 
  { reasonHeading: t('reason2-h3'), reasonDescription: t('reason2-p'), reasonIcon: 'https://cdn.solssmart.org/static/careers/reasons/award-winning-humanitarian-organization.png'}, 
  { reasonHeading: t('reason3-h3'), reasonDescription: t('reason3-p'), reasonIcon: 'https://cdn.solssmart.org/static/careers/reasons/understand-malaysia.png'}, 
  { reasonHeading: t('reason4-h3'), reasonDescription: t('reason4-p'), reasonIcon: 'https://cdn.solssmart.org/static/careers/reasons/broaden-horizons.png'}, 
]
  
  return (
    <section className="fullWidthBG last">
      <div className="fullWidthInner">
        <h2 className="centerContent">{t('reasons-career-h2')}</h2>

        <Grid container spacing={6} className={styles.reasonList}>
          {
            reason_cards?.map(link => (
              <Grid item xs={12} sm={6} key={'reasonpost-'+link.reasonHeading} >
                <Card elevation={0}  className={styles.reasonCard}>
                  <div className={styles.reasonImage}>
                    <Image
                      src={link.reasonIcon}
                      alt={link.reasonHeading} 
                      width={100}
                      height={100}
                      layout="fixed"
                    />
                  </div>

                  <div className={styles.reasonContent}>
                    <h3>{link.reasonHeading}</h3>
                    <p>{link.reasonDescription}</p>
                  </div>
                </Card>
              </Grid>
            ))
          }
        </Grid>
    
      </div>
    </section> 
  )
}

interface Props {
  t: TFunction
}

export default ReasonCards
